<template>
  <div v-clickoutside="hideHelpActions" class="adminActions">
    <input type="checkbox" name="adminToggle" class="adminToggle" v-model="showSubActions" />
    <a
      class="adminButton tooltip"
      :title="showSubActions ? 'Cerrar' : 'Contactanos'"
      id="contactanos"
      href="#!"
      @click="showSubActions = !showSubActions"
      ><i v-if="!showSubActions" class="mdi mdi-lifebuoy"></i><i v-else class="mdi mdi-close"></i>
    </a>

    <div class="adminButtons">
      <a
        @click="hideHelpActions"
        href="https://api.whatsapp.com/send?phone=5219981791733&text=Hola%2c%20%20Peopleware%20Team%f0%9f%92%a1"
        target="_blank"
        id="WhatsApp"
        ><i class="mdi mdi-whatsapp"></i
      ></a>
      <a @click="hideHelpActions" href="https://t.me/peopleware_app" target="_blank" id="Telegram"
        ><i class="mdi mdi-telegram"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpButton',
  data() {
    return {
      showSubActions: false,
    };
  },
  methods: {
    hideHelpActions() {
      this.showSubActions = false;
    },
  },
};
</script>

<style lang="scss">
.adminActions {
  position: fixed;
  bottom: 35px;
  right: 35px;
  z-index: 150;
}

.adminButton {
  height: 40px;
  width: 40px;

  background-color: #3d65c0;
  border-radius: 50%;
  display: block;
  color: #fff;
  text-align: center;
  position: relative;
  z-index: 1070;
}

.adminButton:hover {
  color: #fff;
}

.adminButton i {
  font-size: 21px;
}

.adminButtons {
  position: absolute;
  width: 100%;
  bottom: 120%;
  text-align: center;
  display: none;
}

.adminButtons a {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-decoration: none;
  margin: 10px auto 0;
  line-height: 1.15;
  color: #fff;
  opacity: 0;
  visibility: hidden;
  position: relative;
}

.adminButtons a:hover {
  /* transform: scale(1.1); */
  color: white;
}

.adminButtons a:nth-child(1) {
  background-color: #25d366;
  transition: opacity 0.2s ease-in-out 0.3s, transform 0.15s ease-in-out;
}
.adminButtons a:nth-child(2) {
  background-color: #0088cc;
  transition: opacity 0.2s ease-in-out 0.25s, transform 0.15s ease-in-out;
}

.adminActions a i {
  font-size: 24px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.adminToggle {
  display: none;
  -webkit-appearance: none;
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-color: transparent;
  border: none;
  outline: none;
  z-index: 2;
  transition: box-shadow 0.2s ease-in-out;
  box-shadow: 0 3px 5px 1px rgba(51, 51, 51, 0.3);
}

.adminToggle:hover {
  box-shadow: 0 3px 6px 2px rgba(51, 51, 51, 0.3);
}

.adminToggle:checked ~ .adminButtons {
  display: block;
}

.adminToggle:checked ~ .adminButtons a {
  opacity: 1;
  visibility: visible;
}

.adminToggle:checked ~ .adminButton i.mdi-close {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.adminToggle:checked ~ .adminButton i.mdi-lifebuoy {
  opacity: 0;
  animation-name: fadeOutOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}
.adminButton i.mdi-lifebuoy {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}
.adminButton i.mdi-close {
  opacity: 0;
  animation-name: fadeOutOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOutOpacity {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
